import React from 'react';
import PropTypes from 'prop-types';
import styles from './SearchBar.module.scss';

const SearchBar = ({ handleChange, placeholder }) => {
  return (
    <div className={styles.search}>
      <input type="text" onChange={handleChange} placeholder={placeholder} />
      <div className={styles.searchIcon}>
        <i className="material-icons">search</i>
      </div>
    </div>
  );
};

SearchBar.defaultProps = {
  placeholder: 'Search',
};

SearchBar.propTypes = {
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default SearchBar;
